export const VALIDATION_ERRORS = {
  notEmpty: 'Поле не может быть пустым',
  email: 'Введите валидный email',
};
